// extracted by mini-css-extract-plugin
export var deleteModal = "_i1-0";